import React, { Component } from "react";
import * as Yup from 'yup';
import { Formik, useFormik, yupToFormErrors } from 'formik';
import moment from "moment";
import { EditorState, convertToRaw } from 'draft-js'
import {
    DialogContent,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemSecondaryAction,
    FormControl,
    FormControlLabel,
    InputLabel,
    Input,
    Select,
    MenuItem,
    Divider,
    Hidden,
    Checkbox,
    Switch,
    Button,
    Paper,
    Typography,
    TextField,
    Grid, IconButton, Tooltip, Slider
} from "@material-ui/core";
import {
    Photo as PhotoIcon
} from "@material-ui/icons";
import BaseArrayTable from "./BaseArrayTable";
import MUIRichTextEditor from 'mui-rte'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import CroppableImage from "../../components/CroppableImage/CroppableImage";
import * as RFIcon from 'react-feather'; 
import CroppableImage1 from "../../components/CroppableImage/CroppableImage1";
import language from "../../languages";
import Autocomplete from '@material-ui/lab/Autocomplete';
import BaseArrayPills from "./BaseArrayPills";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            // width: 250,
        },
    },
};

const defaultTheme = createMuiTheme()

Object.assign(defaultTheme, {
    overrides: {
        MUIRichTextEditor: {
            root: {
                width: '100%',
                minHeight: 500,
                left: '5.8%',
                right: '22.8%',
                top: '35.43%',
                bottom: '11.74%',
                boxShadow: 'aqua',
                border: "10px solid #e4e4e4",
                // borderRadius: 10
            },
            editor: {
                // borderBottom: "1px solid gray" 
            }
        }
    }
})

function setFile(field, formik, nativeFile){
        _getBase64(nativeFile, (dataUrl) => {
           formik.setFieldValue(field, dataUrl);
        }, error => {
            //this.props.openSnackbar("Error Converting File", 'error');
        })
}

const setEditor = (field, formik, data) => {
    // console.log(JSON.stringify(convertToRaw(data.getCurrentContent())))
    // formik.setFieldValue(field.name, JSON.stringify(convertToRaw(data.getCurrentContent())));
    formik.setFieldValue(field.name, data);
}

function _getBase64(file, success, failure) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        success(reader.result);
    };
    reader.onerror = function (error) {
        failure(error);
    };
}

function beforeSave(meta, row){
    let newRow = {};
    meta.fields.forEach(field=>{
        let val = undefined;
        if(field.dataType == 'boolean'){
            newRow[field.name] = (row[field.name] === true || row[field.name] === false) ? row[field.name] : false ;
        }else if(field.dataType == 'array'){
            newRow[field.name] = (row[field.name] && row[field.name].length > 0) ? row[field.name] : []
        }else if(row[field.name]){
            if(field.dataType == 'timestamp'){
                val = moment(row[field.name]).unix();
            }else if(field.type == 'number' && field.toFixed){
                val = Number((Math.round(row[field.name] * 100) / 100).toFixed(field.toFixed))
            }
            else{
                val = row[field.name]
            }
            newRow[field.name] = val;
        }else{
            if(field.type == 'number'){
                newRow[field.name] = Number(row[field.name])
            }
        }
    });
    if(row.id){
        newRow.id = row.id;
    }
    return newRow;
}

const isBase64 = (media) => {
    if (media instanceof Boolean || typeof media === 'boolean') {
        return false
    }
    const regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+\/]{3}=)?'
    const mimeRegex = '(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)'
    const newRegex = mimeRegex + '?' + regex

    return (new RegExp('^' + newRegex + '$', 'gi')).test(media)
}

export default function InternalForm(props) {
    const { meta, initialRow, handleCancel, handleSave, classes, onlyForm, selectInputItems, lang } = props;
    //const initialVal = getInitialValues(meta, row);
    const [cropImageOpen, setCropImageOpen] = React.useState(false);
    // console.log(initialRow)
    const formik = useFormik({
        initialValues: initialRow,
        enableReinitialize:true,
        validationSchema: meta.validationSchema || (meta.getValidationSchema && meta.getValidationSchema(initialRow)) || Yup.object({}),
        onSubmit: formRow => {
            const newRow = beforeSave(meta, formRow);
            handleSave(newRow)
        },
    });
    
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    }

    return <React.Fragment>
        <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            { !onlyForm && 
                <Box className={classes.title}>
                    <Typography variant="h6" noWrap>
                        { (initialRow && initialRow.id) ? language[lang].Edit + ' ' : language[lang].Add + ' ' } {meta.entityName}
                    </Typography>
                    <div className={classes.actionArea}>
                    { handleCancel && <Button variant="outlined" onClick={handleCancel} className={classes.cancelButton}>{language[lang].Cancel}</Button> }
                    { handleSave && <Button variant='contained' type='submit' className={classes.saveButton}>{language[lang].Save}</Button>}
                    </div>
                </Box>
            }
            <Box p={2} >
            <List disablePadding>
                <Box mb={1}>
                    {   meta.settingsFields ? 
                        <Grid container>
                            <Grid item container xs={12} >
                            { formik.values.input == 'file' ?
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item xs={12} md={2}>
                                    <Typography variant="subtitle2" style={{fontWeight: 'bold', color: '#09205C'}} gutterBottom>{formik.values.label}: </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Grid container justify="center">
                                        <Grid item style={{ position: 'relative' }}>
                                            <img src={formik.values['value']} alt="Preview"
                                                style={{ height: '40px' }}
                                            />
                                            { isBase64(formik.values['value']) && 
                                            <>
                                                <Tooltip title="Crop Image" placement="bottom" enterDelay={500}>
                                                    <IconButton onClick={() => setCropImageOpen(true)} component='span' size="small" style={{ position: 'absolute', top:-12, right:-12, }}>
                                                        <RFIcon.Edit2 strokeWidth={2} size={20} />
                                                    </IconButton>
                                                </Tooltip>
                                                <CroppableImage1 labelModal='simple-modal' 
                                                    labelDes='simple-modal-des' 
                                                    open={cropImageOpen} 
                                                    isAvatar={formik.values.isAvatar}
                                                    close={() => setCropImageOpen(false)}
                                                    media={formik.values['value']} 
                                                    lang={lang}
                                                    onSave={(dataUrl) => formik.setFieldValue('value', dataUrl)}
                                                />
                                            </>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <input
                                        id="brand-logo-input"
                                        type="file"
                                        name='value'
                                        hidden
                                        accept="image/*"
                                        onChange={(e)=> {setFile('value', formik, e.currentTarget.files[0])}}
                                    />

                                    <label htmlFor="brand-logo-input">
                                        <Button
                                            color="primary"
                                            component="span"
                                            variant="contained"
                                            className={classes.saveButton}
                                        >
                                            {language[lang].Choose_Image}
                                        </Button>
                                    </label>
                                </Grid>
                            </Grid>
                            :
                            formik.values.input == 'select' ? 
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item xs={12} md={2}>
                                    <Typography variant="subtitle2" style={{fontWeight: 'bold', color: '#09205C'}} gutterBottom>{formik.values.label}: </Typography>
                                </Grid>
                                <Grid item xs={12} md={9}>
                                    <FormControl
                                        disabled={false}
                                        fullWidth
                                        size="small"
                                        variant="outlined">
                                        <Select
                                            value={formik.values['value'] || ''}
                                            labelWidth={100}
                                            onChange={formik.handleChange}
                                            name='value'
                                            {...formik.getFieldProps('value')}
                                            error={formik.touched['value'] && Boolean(formik.errors['value'])}
                                            helpertext={formik.errors['value']}
                                        >
                                            {
                                                formik.values.getItems.map((item, i) =>
                                                    <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={1}>
                                    <Tooltip title={formik.values.description} placement="bottom" >
                                        <RFIcon.HelpCircle color='#2735A4' strokeWidth={2} />
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            :
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item xs={12} md={2}>
                                    <Typography variant="subtitle2" style={{fontWeight: 'bold', color: '#09205C'}} gutterBottom>{formik.values.label}: </Typography>
                                </Grid>
                                <Grid item xs={12} md={9}>
                                    <FormControl
                                        fullWidth
                                        variant="outlined"
                                        size="small">
                                        <TextField id='value'
                                            variant="outlined"
                                            size="small"
                                            value={formik.values['value'] || ''}
                                            multiline={formik.values.multiline}
                                            {...formik.getFieldProps('value')}
                                            error={formik.touched['value'] && Boolean(formik.errors['value'])}
                                            helperText={formik.errors['value']}
                                            rows={formik.values.rows || 1}
                                            name='value'
                                            disabled={formik.values.disabled}
                                            onChange={formik.handleChange} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={1}>
                                    <Tooltip title={formik.values.description} placement="bottom" >
                                        <RFIcon.HelpCircle color='#2735A4' strokeWidth={2} />
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            }
                            </Grid>
                            <Grid item container xs={12} style={{marginTop: 16}} >
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item xs={12} md={2}>
                                    <Typography variant="subtitle2" style={{fontWeight: 'bold', color: '#09205C'}} gutterBottom>{language[lang].Description}: </Typography>
                                </Grid>
                                <Grid item xs={12} md={9}>
                                    <FormControl
                                        fullWidth
                                        variant="outlined"
                                        size="small">
                                        <TextField id='description'
                                            variant="outlined"
                                            size="small"
                                            value={formik.values['description'] || ''}
                                            multiline={true}
                                            {...formik.getFieldProps('description')}
                                            error={formik.touched['description'] && Boolean(formik.errors['description'])}
                                            helperText={formik.errors['description']}
                                            rows={3}
                                            name='description'
                                            disabled={true}
                                            onChange={formik.handleChange} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={1}>

                                </Grid>
                            </Grid>
                            </Grid>
                        </Grid>
                        :
                        meta.fields.map((metaField, i) => {
                            let comp = null;
                            switch (metaField.input) {
                                case 'text':
                                    comp = <FormControl
                                        fullWidth
                                        variant="outlined">
                                        <TextField id={metaField.name} label={metaField.label}
                                            variant="outlined"
                                            value={formik.values[metaField.name] || ''}
                                            multiline={metaField.multiline}
                                            {...formik.getFieldProps(metaField.name)}
                                            error={formik.touched[metaField.name] && Boolean(formik.errors[metaField.name])}
                                            helperText={formik.errors[metaField.name]}
                                            rows={metaField.rows || 1}
                                            name={metaField.name}
                                            type={metaField.type ? metaField.type : 'text'}
                                            disabled={(metaField.disabled || (metaField.isDisabled && metaField.isDisabled(formik.values[metaField.disableValue])) ) ? true : false}
                                            onChange={formik.handleChange} />
                                    </FormControl>
                                    break;
                                case 'select':
                                    comp = <FormControl
                                        // disabled={false}
                                        fullWidth
                                        variant="outlined">
                                        <InputLabel>
                                            {metaField.label}
                                        </InputLabel>
                                        <Select
                                            value={formik.values[metaField.name] || ''}
                                            labelWidth={100}
                                            onChange={formik.handleChange}
                                            name={metaField.name}
                                            disabled={(metaField.disabled || (metaField.isDisabled && metaField.isDisabled(formik.values[metaField.disableValue])) ) ? true : false}
                                            {...formik.getFieldProps(metaField.name)}
                                            error={formik.touched[metaField.name] && Boolean(formik.errors[metaField.name])}
                                            helpertext={formik.errors[metaField.name]}
                                        >
                                            {
                                                selectInputItems[metaField.name] && selectInputItems[metaField.name].map((item, i) =>
                                                    <MenuItem key={i} value={item.value} disabled={item.disabled}>{item.label}</MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                    break;
                                case 'multiselect':
                                    comp = <FormControl className={classes.formControl} fullWidth>
                                        <InputLabel id={metaField.name}>{metaField.label}</InputLabel>
                                        <Select
                                            labelId={metaField.name}
                                            id={metaField.name}
                                            multiple
                                            value={formik.values[metaField.name]}
                                            onChange={formik.handleChange}
                                            input={<Input />}
                                            name={metaField.name}
                                            renderValue={(selected) => {
                                                return selected.map((item, i) => {
                                                    return <Typography key={i} type='subtitle2' component='span'> 
                                                            {selectInputItems[metaField.name] && 
                                                                selectInputItems[metaField.name].find(parent => parent.value == item).label}{i < (selected.length-1) && ', '} 
                                                        </Typography>
                                                })
                                            }}
                                            MenuProps={MenuProps}
                                            {...formik.getFieldProps(metaField.name)}
                                            error={formik.touched[metaField.name] && Boolean(formik.errors[metaField.name])}
                                            helpertext={formik.errors[metaField.name]}
                                        >
                                            {selectInputItems[metaField.name] && selectInputItems[metaField.name].map((item, i) => {
                                                // { console.log( row[metaField.name].indexOf(item.value) > -1 ) }
                    
                                                return formik.values[metaField.name] && <MenuItem key={i} value={item.value} disabled={item.isDisabled}>
                                                    <Checkbox checked={formik.values[metaField.name].indexOf(item.value) > -1} />
                                                    <ListItemText primary={item.label} />
                                                </MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                    break;
                                case 'slider':
                                    comp = <FormControl className={classes.formControl} fullWidth>
                                        {/* <InputLabel id={metaField.name}>{metaField.label}</InputLabel> */}
                                        <Typography id={metaField.name} gutterBottom>
                                            {metaField.label}
                                        </Typography>
                                        <Slider
                                            defaultValue={formik.values[metaField.name] ? formik.values[metaField.name] : 1}
                                            // getAriaValueText={valuetext}
                                            aria-label={metaField.label}
                                            valueLabelDisplay="auto"
                                            step={metaField.steps}
                                            id={metaField.name}
                                            name={metaField.name}
                                            marks={metaField.marks}
                                            onChange={(event, newValue) => formik.setFieldValue(metaField.name, newValue)}
                                            min={metaField.min}
                                            max={metaField.max}
                                        />
                                    </FormControl>
                                    break;
                                case 'autocomplete':
                                    comp = <FormControl
                                        disabled={false}
                                        fullWidth
                                        variant="outlined">
                                        <Autocomplete
                                            id={metaField.name}
                                            name={metaField.name}
                                            disabled={(metaField.disabled || (metaField.isDisabled && metaField.isDisabled(formik.values[metaField.disableValue])) ) ? true : false}
                                            defaultValue={formik.values[metaField.name] ? formik.values[metaField.name] : ''}
                                            onChange={(event, value, reason) => {formik.setFieldValue(metaField.name, value ? value.value : '' )}}
                                            options={selectInputItems[metaField.name] || []}
                                            getOptionLabel={(option) => {
                                                if(option){
                                                    let optionObj = selectInputItems[metaField.name].find((item) => item.value == option)
                                                    return optionObj ? optionObj.label : option.label
                                                }else{
                                                    return ''
                                                }
                                            }}
                                            getOptionSelected={(option, value) => (option.value == value || option.value == value.value)}
                                            renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={metaField.label}
                                                variant="outlined"
                                            />
                                            )}
                                        />
                                    </FormControl>
                                    break;
                                case 'datetime':
                                    comp = <FormControl
                                        disabled={false}
                                        fullWidth
                                        variant="outlined"
                                    >
                                        <TextField
                                            id={metaField.name}
                                            label={metaField.label}
                                            type="datetime-local"
                                            value={formik.values[metaField.name]}
                                            name={metaField.name}
                                            onChange={formik.handleChange}
                                            {...formik.getFieldProps(metaField.name)}
                                            error={formik.touched[metaField.name] && Boolean(formik.errors[metaField.name])}
                                            helperText={formik.errors[metaField.name]}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </FormControl>
                                    break;
                                case 'timepicker':
                                    comp = <FormControl
                                        disabled={false}
                                        fullWidth
                                        variant="outlined"
                                    >
                                        <TextField
                                            id={metaField.name}
                                            label={metaField.label}
                                            type="time"
                                            value={formik.values[metaField.name]}
                                            name={metaField.name}
                                            onChange={formik.handleChange}
                                            {...formik.getFieldProps(metaField.name)}
                                            error={formik.touched[metaField.name] && Boolean(formik.errors[metaField.name])}
                                            helperText={formik.errors[metaField.name]}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </FormControl>
                                    break;
                                case 'switch':
                                    comp = <FormControlLabel
                                        control={
                                            <Switch
                                                checked={formik.values[metaField.name] ? formik.values[metaField.name] : false}
                                                onChange={formik.handleChange}
                                                name={metaField.name}
                                                color={metaField.color}
                                                {...formik.getFieldProps(metaField.name)}
                                            // error={formik.touched[metaField.name] && Boolean(formik.errors[metaField.name])}
                                            helpertext={formik.errors[metaField.name]}
                                            />
                                        }
                                        label={metaField.label}
                                        variant="outlined"
                                    />
                                    break;
                                case 'arrayTable':
                                    comp = <>
                                            
                                            <Box>
                                                <h4>{metaField.label}</h4>
                                                <BaseArrayTable 
                                                    rows={formik.values[metaField.name]}
                                                    tableDef={metaField.tableDef}
                                                    formik={formik}
                                                    fieldName={metaField.name}
                                                    lang={lang}
                                                    metaField={metaField}
                                                />
                                            </Box>
                                        </>
                                    break;
                                case 'arrayPills':
                                    comp = <>
                                            
                                            <Box>
                                                <h4>{metaField.label}</h4>
                                                <BaseArrayPills
                                                    rows={formik.values[metaField.name]}
                                                    formik={formik}
                                                    fieldName={metaField.name}
                                                    lang={lang}
                                                    metaField={metaField}
                                                />
                                            </Box>
                                        </>
                                    break;
                                case 'editor':
                                    comp = 
                                        <Grid container justify="center">
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" gutterBottom>Content:</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                            <Box>
                                                <MuiThemeProvider theme={defaultTheme}>
                                                    <MUIRichTextEditor 
                                                        label={metaField.label}
                                                        defaultValue={formik.values[metaField.name]}
                                                        onSave={(editorData) => setEditor(metaField, formik, editorData)}
                                                    />
                                                </MuiThemeProvider>
                                            </Box>
                                            </Grid>
                                        </Grid>
                                    break;
                                case 'file':
                                    comp = <>
                                        <Grid container justify="center">
                                            <Grid item style={{ position: 'relative' }}>
                                                <img src={formik.values[metaField.name]} alt="Preview"
                                                    style={metaField.isAvatar ? { display: 'block', width: '300px', borderRadius: '50%' }: { display: 'block', width: '300px' } } 
                                                />
                                                {formik.values[metaField.name] && isBase64(formik.values[metaField.name]) && 
                                                <>
                                                    <Tooltip title="Crop Image" placement="bottom" enterDelay={500}>
                                                        <IconButton onClick={() => setCropImageOpen(true)} style={{ position: 'absolute', top:0, right:0, }}>
                                                            <RFIcon.Edit2 strokeWidth={2} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <CroppableImage1 labelModal='simple-modal' 
                                                        labelDes='simple-modal-des' 
                                                        open={cropImageOpen} 
                                                        isAvatar={metaField.isAvatar}
                                                        close={() => setCropImageOpen(false)}
                                                        media={formik.values[metaField.name]} 
                                                        lang={lang}
                                                        onSave={(dataUrl) => formik.setFieldValue(metaField.name, dataUrl)}
                                                    />
                                                </>
                                                }
                                            </Grid>
                                        </Grid>
                                        <>
                                            <input
                                                id={metaField.name}
                                                type="file"
                                                name={metaField.name}
                                                hidden
                                                accept="image/*"
                                                onChange={(e)=> {setFile(metaField.name, formik, e.currentTarget.files[0])}}
                                            />
                    
                                            <label htmlFor={metaField.name}>
                                            <Button
                                                color="primary"
                                                component="span"
                                                variant="contained"
                                                className={classes.saveButton}
                                            >
                                                {language[lang].Choose_Image}
                                            </Button>
                                            </label>
                                        </>
                                    </>
                                    break;
                                default:
                                    comp = null
                            }
                            return <ListItem key={i}>
                                {comp}
                            </ListItem>
                        })
                    }
                    <ListItem >
                        {/* {  onlyForm && handleCancel && <Button variant="contained" onClick={handleCancel} style={{ margin: '5px' }}>Cancel</Button> } */}
                        {  onlyForm && handleSave && <Button variant='contained' type='submit' className={classes.saveButton} >{language[lang].Save}</Button>}
                    </ListItem>
                </Box>
            </List>
            </Box>
        </form>
    </React.Fragment>
}